import React from "react";
import { Link } from "@/i18n/routing";
import Image from "next/image";
import SocialMedia from "../header/social";
import Script from "next/script";

const Footer = () => {
  return (
    <div className=" h-full  bg-secondary text-white pt-32 px-8 lg:px-24 flex flex-col justify-between overflow-hidden ">
      {/* First row */}
      <div className="flex justify-between gap-16 max-[1000px]:flex-col">
        {/* Contact section */}
        <div className="flex-1 flex flex-col gap-6 text-center items-center lg:text-start lg:items-start">
                <Link href="/" rel="preload">
                    <div className="relative h-10 w-64 md:h-16 md:w-96 lg:h-20 lg:w-[28rem] xl:h-24 xl:w-[32rem]">
  <Image
    src="/evinov.avif"
    alt="evinov"
    fill
    sizes="(max-width: 768px) 384px, (max-width: 1024px) 448px, 512px"
    style={{ objectFit: 'contain' }}
    priority
  />
</div>
   </Link>
         <p className="text-white text-xl lg:w-2/3 font-light">
           A trusted partner for building, growing, and maintaining your online presence with modern, reliable, and tailored web solutions.
         </p> 
   <>
      <Link
        href="//www.dmca.com/Protection/Status.aspx?ID=f6640110-0cee-4295-86c2-c4f24fdbb44d"
        title="DMCA.com Protection Status"
        className="dmca-badge"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image
          src="https://images.dmca.com/Badges/dmca_protected_15_120.png?ID=f6640110-0cee-4295-86c2-c4f24fdbb44d"
          alt="DMCA.com Protection Status"
          width={120}
          height={15}
          unoptimized
        />
      </Link>
      <Script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js" />
    </>      
    
    </div>

        <div className="text-center items-center pt-16 space-y-4">
          <p className="text-3xl md:text-4xl font-extrabold">213-772-057-037</p>
          <p className="text-3xl font-semibold">contact@evinov.dev</p>
          <SocialMedia/>
        </div>

        {/* Navigation section */}
        <div className="flex-1 flex flex-col items-end max-[1000px]:items-start">


          <Link
            href="/studies"
            className="w-1/2 py-4 flex justify-between border-t border-dashed border-primary max-[1000px]:w-full"
          >
            <span className="hover:text-primary">Case Studies</span>
            <span>&#8594;</span>
          </Link>

         

          <Link
            href="/trends"
            className="w-1/2 py-4 flex justify-between border-t border-dashed border-primary  max-[1000px]:w-full"
          >
            <span className="hover:text-primary">Digital Trends</span>
            <span>&#8594;</span>
          </Link>

          <Link
            href="/about-us"
            className="w-1/2 py-4 flex justify-between border-t border-b border-dashed border-primary max-[1000px]:w-full"
          >
            <span className="hover:text-primary">About</span>
            <span>&#8594;</span>
          </Link>
            <Link
            href="/contact-us"
            className="w-1/2 py-4 flex justify-between border-t border-b border-dashed border-primary max-[1000px]:w-full"
          >
            <span className="hover:text-primary">Contact</span>
            <span>&#8594;</span>
          </Link>
        </div>
      </div>

      {/* Second row */}
      <div>
        {/* Header */}
        <div className="w-full py-16 flex justify-between items-end ">
         
        </div>

        {/* Copyright line */}
        <div className="w-full py-2  flex justify-between gap-3 flex-wrap items-start border-t border-dashed border-primary">
          <p className=" text-sm">All rights reserved &copy; 2026</p>
          <div className="flex gap-3 lg:gap-6 flex-wrap capitalize">
            <Link href={"/privacy-policy"}>
              <p className=" text-sm text-right hover:text-primary">
            Privacy Policy 
          </p>
            </Link>
         <Link href={"/terms-and-conditions"}>
          <p className=" text-sm text-right hover:text-primary">
          Terms and Conditions
          </p>
          </Link>
          <Link href={"/cookies-policy"}>
          <p className=" text-sm text-right hover:text-primary">
          Cookies Policy
          </p>
          </Link>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default Footer;










/** <h1 className="relative -left-[0.5vw] text-[15vw]">Nico</h1>
          <h1 className="relative -left-[0.5vw] text-[15vw]">Palmer</h1> */